import {
  SET_SWATCH_COLOR_NAME,
  SET_SELECTED_PRODUCTS_DATA,
  SET_INIT_SELECTED_PRODUCTS_DATA,
  SET_INVENTORY_DATA,
  SET_PROJECTION_DATA,
  SET_INVENTORY_STATUS,
} from "./actionTypes"

/**
 * Sets user info and token in the context store
 * @param {Object} payload The user login data
 * @return {Object} The action object with type and payload
 */
export const setSwatchColorAction = payload => ({
  type: SET_SWATCH_COLOR_NAME,
  payload,
})

/**
 * Action creator for setting selected products data.
 *
 * @param {Object} payload - The data to set for the selected products.
 * @return {Object} The action object containing the type and payload.
 */
export const setSelectedProductsAction = payload => ({
  type: SET_SELECTED_PRODUCTS_DATA,
  payload,
})
/**
 * Action creator for setting selected products data.
 *
 * @param {Object} payload - The data to set for the selected products.
 * @return {Object} The action object containing the type and payload.
 */
export const setInitSelectedProductsAction = payload => ({
  type: SET_INIT_SELECTED_PRODUCTS_DATA,
  payload,
})

/**
 * Action creator for setting inventory data.
 *
 * @param {Object} payload - The data to be set in the inventory.
 * @return {Object} The action object containing the type and payload.
 */
export const setInventoryDataAction = payload => ({
  type: SET_INVENTORY_DATA,
  payload,
})

/**
 * Creates an action to set the inventory status.
 *
 * @param {Boolean} payload - The data to update the inventory status with.
 * @return {Boolean} The action object with type and payload.
 */
export const setInventoryStatusAction = payload => ({
  type: SET_INVENTORY_STATUS,
  payload,
})

/**
 * Action creator for setting projection data.
 *
 * @param {Object} payload - The data to be set in the projection.
 * @return {Object} The action object containing the type and payload.
 */
export const setProjectionDataAction = payload => ({
  type: SET_PROJECTION_DATA,
  payload,
})
